import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { projectImportFileAction } from '@/redux/actions/project-import';
import { TProjectImportFileResponse, projectImportFile } from '@/services/api/project-import';

// FUNCTION
export function* projectImportFileSaga(action: ActionType<typeof projectImportFileAction.request>): Generator {
  const { materials, companyId, projectId, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(projectImportFile, materials, companyId, projectId);
    const projectImportFileResponse: TProjectImportFileResponse = response as TProjectImportFileResponse;
    yield put(projectImportFileAction.success(projectImportFileResponse));
    successCallback?.(projectImportFileResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getProjectPDFFileError');
    yield put(projectImportFileAction.failure(err));
    failedCallback?.(err);
  }
}
